module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Adress-book#2-1e460ead84294c5319f23d7f6dd75cb7.svg";